<template>
    <div class="industy-block">
      <div class="fold-btn"
           @click="foldBtn">{{foldBtnContent}}</div>
  
      <div class="top-charts">
        <div class="mark-line">
          <canvas class="mk"
                  :id='"markLine"+type.type'
                  width="600"
                  height="300"></canvas>
        </div>
        <div class="chart-tag">
          <div class="chart-title-tag"
               :class="[chartType === 'capital' ? 'selected':'']"
               @click="changeType('capital')">市值</div>
        </div>
        <div class="chart">
          <chart ref="chart1"
                 :opt="opt1"></chart>
        </div>
        <div class="chart">
          <chart ref="chart2"
                 :opt="opt2"></chart>
        </div>
      </div>
      <hqtable ref="hqtable"
               class="table"
               :data="tdata"
               :thead="thead"
               :fixed="fixed"
               :subset="subset"
               :sort.sync="sort"
               :codeKey="codeKey"
               @on-row-click="rowClick"
               @on-th-click="target">
        <div style="width:100%; padding:100px 0;text-align: center;"
             slot="nodata">{{tableTips}}</div>
        <template v-slot:extend="extend">
          <div slot="extend"
               style="display:table-row-group; vertical-align:middle; border-color:inherit">
            <div class="hq_tr"
                 v-if="total"
                 @click="clickOther('000985')"
                 v-bind:class="[ selectedCode === '000985'?'hq_tr_active':'']">
              <div :td-key="thead[0]['key']"
                   :style="{width:extend.widths[0]+'px'}"
                   class="td-word"
                   @dblclick="jumptoALl()">合计</div>
              <div :td-key="thead[1]['key']"
                   :style="{width:extend.widths[1]+'px'}"
                   class="td-word"
                   @dblclick="jumptoALl()">{{total.code}}</div>
              <div :td-key="thead[2]['key']"
                   :style="{width:extend.widths[2]+'px'}">
                <span :class="[total.sixty_change > 0 ? 'red' : 'green']">{{total.sixty_change ? Number(total.sixty_change).toFixed(2) + '%' : '--'}}</span>
              </div>
              <div :td-key="thead[3]['key']"
                   :style="{width:extend.widths[3]+'px'}">{{total.hold_amount}}</div>
              <div :td-key="thead[4]['key']"
                   :style="{width:extend.widths[4]+'px'}">{{Number(total.share_market_capital / 100000000).toFixed(2)}}亿</div>
              <div :td-key="thead[5]['key']"
                   :style="{width:extend.widths[5]+'px'}">
                <span :class="[total.market_capital_change > 0 ? 'red' : 'green']">{{Number(total.market_capital_change / 100000000).toFixed(2)}}亿</span>
              </div>
            </div>
          </div>
        </template>
      </hqtable>
  
      <div class="bottom-chart">
        <div class="chart-title">“{{selectName}}” {{typename}}持股市值图</div>
        <chart ref="chartCompare"
               :opt="chartCompare"></chart>
      </div>
    </div>
  </template>
  
  <script>
  import Chart from '../../lib/echarts-middleware';
  import Hqtable from '../../lib/v-hqtable';
  import { OTHER_CODE , TOTAL_CODE } from '../../configs/index.js';
  
  export default {
    name: 'industryblock',
    props: ['type', 'date', 'resize', 'color', 'resizeType', 'config'],
    components: {
      Chart,
      Hqtable
    },
    created() {
      // this.getDate();
      this.optCapital1.color = this.color.color;
      this.optCapital2.color = this.color.color;
      this.optInflow1.color = this.color.color;
      this.optInflow2.color = this.color.color;
      this.optCapital1.series[0].label.color = this.color.label;
      this.optCapital2.series[0].label.color = this.color.label;
      this.optInflow1.series[0].label.color = this.color.label;
      this.optInflow2.series[0].label.color = this.color.label;
      this.optCapital1.series[0].labelLine.lineStyle.color = this.color.labelLine;
      this.optCapital2.series[0].labelLine.lineStyle.color = this.color.labelLine;
      this.optInflow1.series[0].labelLine.lineStyle.color = this.color.labelLine;
      this.optInflow2.series[0].labelLine.lineStyle.color = this.color.labelLine;
    },
    mounted() {},
    data() {
      return {
        // 表格的属性
        sort: { key: 'share_market_capital', type: 'down' },
        subset: true,
        thead: [
          {
            key: 'name',
            name: '行业',
            width: 110,
            class: ['t-head', 'td-head', 'td_name'],
            events: {
              dblclick: (e, data) => {
                const { selectedCode } = data;
                // 999991是其他，99992是合计，三期优化前逻辑，要注意
                if (selectedCode && selectedCode !== OTHER_CODE && selectedCode !== TOTAL_CODE && selectedCode !== '--') {
                  if (this.type.type - 0 === 1) {
                    TA.log({ id: 'cgpz_lgt_hytj_41', _sid: 'cgpz_lgt_hytj_41' });
                  } else {
                    TA.log({ id: 'cgpz_ggt_hytj_41', _sid: 'cgpz_ggt_hytj_41' });
                  }
  
                  API.use({
                    method: 'Quote.switchPage',
                    data: {
                      id: '65',
                      code: selectedCode
                    }
                  });
                }
              }
            },
            format: function(v, tr) {
              let icon = '';
              if (!tr.isSub && tr.subset && tr.subset.length && tr.subState) {
                icon = "<span class='icon-sub'>- </span>";
              } else if (!tr.isSub && tr.subset && tr.subset.length && !tr.subState) {
                icon = "<span class='icon-sub'>+ </span> ";
              } else {
                icon = '';
              }
              return '<div class="ta-left txt-hide" title="'+v+'">' + icon + v + "</div>";
            }
          },
          {
            key: 'selectedCode',
            name: '代码',
            class: ['t-head', 'td-head', 'td_industry_code'],
            width: 55,
            events: {
              dblclick: (e, data) => {
                const { selectedCode } = data;
                 // 999991是其他，99992是合计，三期优化前逻辑，要注意
                if (selectedCode && selectedCode !== OTHER_CODE && selectedCode !== TOTAL_CODE && selectedCode !== '--') {
                  if (this.type.type - 0 === 1) {
                    TA.log({ id: 'cgpz_lgt_hytj_41', _sid: 'cgpz_lgt_hytj_41' });
                  } else {
                    TA.log({ id: 'cgpz_ggt_hytj_41', _sid: 'cgpz_ggt_hytj_41' });
                  }
                  API.use({
                    method: 'Quote.switchPage',
                    data: {
                      id: '65',
                      code: selectedCode
                    }
                  });
                }
              }
            },
            format: function(v) {
              return v ? v : '--';
            }
          },
          {
            key: 'sixty_change',
            name: '60日涨幅',
            sort: true,
            width: 65,
            class: ['t-head', 'td_week_price_change_ratio'],
            format: function(v) {
              let val = v ? (v).toFixed(2) + '%' : '--';
              if (val === '--') {
                return '--';
              }
              if (val - 0 === 0) {
                return '0.00';
              }
              if (v > 0) {
                return '<span class="red">' + val + '</span>';
              } else {
                return '<span class="green">' + val + '</span>';
              }
            }
          },
          {
            key: 'hold_amount',
            name: '持股个数',
            width: 80,
            sort: true,
            class: ['t-head', 'td_hold_amount'],
            format: function(v) {
              return v ? Number(v) : '--';
            }
          },
          {
          key: "share_market_capital",
          name: "持股市值",
          width: 120,
          sort: true,
          class: ["t-head", "td_share_market_capital"],
          format: function(v) {
            return v ? Number(v / 100000000).toFixed(2) + "亿" : "--";
          }
        },
        {
          key: "market_capital_change",
          name: "本季度市值增减",
          sort: true,
          width: 110,
          class: ["t-head", "td_week_share_market_capital"],
          format: function(v) {
            let val = v ? Number(v / 100000000).toFixed(2) + "亿" : "--";
            if (val === "--") {
              return "--";
            }
            if (val - 0 === 0) {
              return "0.00";
            }
            if (v > 0) {
              return '<span class="red">' + val + "</span>";
            } else {
              return '<span class="green">' + val + "</span>";
            }
          }
        }
        ],
        codeKey: 'code',
        tdata: [],
        fixed: {
          thead: true,
          theadHeight: 30
        },
        // 图表配置
        // 实例
        getchart: false,
        chart1: {},
        chart2: {},
        opt1: {},
        opt2: {},
        chartCompare: {},
        chartType: 'capital',
        // 配置
        optCapital1: {
          animation: false,
          series: [
            {
              name: '市值',
              type: 'pie',
              selectedOffset: 5,
              radius: ['50', '70'],
              center: ['50%', '50%'],
              startAngle: 0,
              label: {
                formatter: p => {
                  return p.name + ':' + Number((p.value / this.total.share_market_capital) * 100).toFixed(2) + '%';
                }
              },
              labelLine: {
                lineStyle: {}
              },
              data: '',
              emphasis: {}
            }
          ]
        },
        optCapital2: {
          animation: false,
          series: [
            {
              name: '市值',
              type: 'pie',
              selectedOffset: 5,
              radius: ['50', '70'],
              center: ['50%', '50%'],
              data: '',
              label: {
                formatter: p => {
                  return p.name + ':' + Number(p.percent).toFixed(2) + '%';
                }
              },
              labelLine: {
                lineStyle: {}
              },
              emphasis: {}
            }
          ]
        },
        optInflow1: {
          animation: false,
          series: [
            {
              name: '流入金额',
              type: 'pie',
              selectedOffset: 5,
              startAngle: 0,
              radius: ['50', '70'],
              center: ['50%', '50%'],
              data: '',
              label: {
                formatter: p => {
                  return p.name + ':' + Number(p.percent).toFixed(2) + '%';
                }
              },
              labelLine: {
                lineStyle: {}
              },
              emphasis: {}
            }
          ]
        },
        optInflow2: {
          animation: false,
          series: [
            {
              name: '流入金额',
              type: 'pie',
              selectedOffset: 5,
              radius: ['50', '70'],
              center: ['50%', '50%'],
  
              data: '',
              label: {
                formatter: p => {
                  return p.name + ':' + Number(p.percent).toFixed(2) + '%';
                }
              },
              labelLine: {
                lineStyle: {}
              },
              emphasis: {}
            }
          ]
        },
        optCompare: {
          grid: {
            bottom: 100
          },
          color: ['#f8b551', '#e74741'],
          legend: {
            bottom: 50,
            itemWidth: 10,
            itemHeight: 10,
            data: [{ name: '流入净额', icon: 'rect' }, { name: '市值', icon: 'rect' }],
            textStyle: {
              color: '#626262'
            }
          },
          dataZoom: [
            {
              type: 'inside',
              start: 20,
              end: 100,
              zoomOnMouseWheel: false
            },
            {
              show: true,
              start: 20,
              end: 100,
              height: 25,
              dataBackgroundColor: '#363636'
            }
          ],
          xAxis: {
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: '#626262'
              }
            },
            axisTick:{
              alignWithLabel:true
            },
            splitLine: {
              show: false
            }
          },
          yAxis: {
            name: '金额(亿)',
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#626262'
              }
            },
            splitLine: {
              show: false
            },
  
            axisLabel: {
              formatter: value => {
                return parseInt(value / 100000000);
              },
              textStyle: {
                decoration: 'none',
                align: 'right'
              },
              interval: 'auto',
              margin: 3
            }
          },
          tooltip: {
            trigger: 'axis',
  
            axisPointer: {
              // type: "cross",
              label: {
                show: false
              },
              crossStyle: {
                type: 'solid'
              }
            },
            formatter: params => {
              this.tooltipTarget();
              // if (this.tooltipTargetFn) {
              //   this.tooltipTargetFn();
              // } else {
              //   this.tooltipTargetFn = window.$util.util.throttle(
              //     this.tooltipTarget,
              //     1000
              //   );
              // }
              let time = '时间：' + params[0].name + '<br/>';
              let result = '';
              for (let [index, value] of params.entries()) {
                result += `${value.seriesName}：${parseInt(params[index].value / 100000000)}亿<br/>`;
              }
              return time + result;
            }
          },
          series: [
            {
              data: [],
              type: 'line',
              name: '流入净额',
              showSymbol: false,
              smooth: true
            },
            {
              data: [],
              type: 'line',
              name: '市值',
              showSymbol: false,
              smooth: true
            }
          ]
        },
        selectedAngel1: 0,
        selectedAngel2: 0,
        markLine: '',
        capitalAll: 0,
        inflowAll: 0,
        other1Code: [],
        other2Code: [],
        // 整体配置
        datafault: false,
        allDate: {},
        partDate: {},
        selectedCode: '',
        selectId: '',
        selectName: '',
        foldAll: false,
        total: '',
        other: '',
        selectedCode1: '',
        selectedCode2: '',
        //埋点
        tooltipTargetFn: '',
        chartCompareDatazoomFn: '',
        chart1MouseoverFn: '',
        chart2MouseoverFn: ''
      };
    },
    methods: {
      // 获取行业列表
      getDate() {
        
      let url =
        `//apigate${process.env.NODE_ENV !== 'production' ? '-test' : ''}.10jqka.com.cn/d/hq/hshkconnect/block/holdconfiguration/v1/get_list`;
      $.ajax({
        type: "GET",
        url: url,
        data: {
          type: "north",
          timestamp: this.date,
          cate: this.type.key
        },
        dataType: "json",
        xhrFields: {
          withCredentials: true
        },
        success: res => {
          if(res.status_code !== 0 || !res.data){
            return;
          }
          const result = res.data.result.map(item => {
            if (!item.code) {
              return {
                ...item,
                code: item.id,
                selectedCode: item.code
              }
            }
            else {
              return item
            }
          })
          if (result && result.length) {
            this.setTableDate(result);
              this.setChartDate();
              this.datafault = false;
              this.selectId = '';
              this.selectedCode = '';
              this.selectedCode1 = '';
              this.selectedCode2 = '';
          } else {
            this.tdata = [];
            this.datafault = true;
          }
        },
        error: function(e) {
          console.log(e);
        }
      });
      },
      getchartsInstance() {
        this.chart1 = this.$refs['chart1'].chart;
        this.chart2 = this.$refs['chart2'].chart;
        this.chartCompare = this.$refs['chartCompare'].chart;
        this.markLine = document.getElementById('markLine' + this.type.type).getContext('2d');
        this.chart1.on('click', params => {
          if (params.componentType === 'series') {
            let name = params.name;
            this.selectedCode1 = this.allDate[name][this.codeKey];
            if (this.type.type - 0 === 1) {
              if (this.chartType === 'capital') {
                TA.log({ id: 'cgpz_lgt_hytj_30_1', _sid: 'cgpz_lgt_hytj_30_1' });
              } else {
                TA.log({ id: 'cgpz_lgt_hytj_31_1', _sid: 'cgpz_lgt_hytj_31_1' });
              }
            } else {
              if (this.chartType === ' ') {
                TA.log({ id: 'cgpz_ggt_hytj_30_1', _sid: 'cgpz_ggt_hytj_30_1' });
              } else {
                TA.log({ id: 'cgpz_ggt_hytj_31_1', _sid: 'cgpz_ggt_hytj_31_1' });
              }
            }
          }
        });
        this.chart1.on('mouseover', params => {
          if (params.componentType === 'series') {
            if (this.chart1MouseoverFn) {
              this.chart1MouseoverFn();
            } else {
              this.chart1MouseoverFn = window.$util.util.throttle(this.chart1Mouseover, 1000);
            }
          }
        });
        this.chart2.on('click', params => {
          if (params.componentType === 'series') {
            let name = params.name;
            this.selectedCode2 = this.partDate[name][this.codeKey];
            this.selectId = this.partDate[name].id;
            if (this.type.type - 0 === 1) {
              if (this.chartType === 'capital') {
                TA.log({ id: 'cgpz_lgt_hytj_30_3', _sid: 'cgpz_lgt_hytj_30_3' });
              } else {
                TA.log({ id: 'cgpz_lgt_hytj_31_3', _sid: 'cgpz_lgt_hytj_31_3' });
              }
            } else {
              if (this.chartType === 'capital') {
                TA.log({ id: 'cgpz_ggt_hytj_30_3', _sid: 'cgpz_ggt_hytj_30_3' });
              } else {
                TA.log({ id: 'cgpz_ggt_hytj_31_3', _sid: 'cgpz_ggt_hytj_31_3' });
              }
            }
          }
        });
        this.chart2.on('mouseover', params => {
          if (params.componentType === 'series') {
            if (this.chart2MouseoverFn) {
              this.chart2MouseoverFn();
            } else {
              this.chart2MouseoverFn = window.$util.util.throttle(this.chart2Mouseover, 1000);
            }
          }
        });
        this.chartCompare.on('datazoom', () => {
          if (this.chartCompareDatazoomFn) {
            this.chartCompareDatazoomFn();
          } else {
            this.chartCompareDatazoomFn = window.$util.util.throttle(this.chartCompareDatazoom, 1000);
          }
        });
        this.getchart = true;
      },
      // 获取分时图数据
      getCompareDate() {
        let url =
        `//apigate${process.env.NODE_ENV !== 'production' ? '-test' : ''}.10jqka.com.cn/d/hq/hshkconnect/block/holdconfiguration/v1/get_chart`;
        $.ajax({
        type: "GET",
        url: url,
        data: {
          type: "north",
          code: this.selectId || this.tdata[0].id,
          cate: this.type.key
        },
        dataType: "json",
        xhrFields: {
          withCredentials: true
        },
        success: response => {
          if (response.status_code !== 0 || !response.data) {
            return;
          }
          // 根据id判断是为了适配原来的逻辑
          const dataList = response.data.result || []
          this.setCompareDate(dataList);
        },
        error: function(e) {
          console.log(e);
        }
      });
      },
    //   总计、其他
      setTableDate(d) {
        this.tdata = [];
        let arr = Object.keys(d);
        for (let i = 0; i < d.length; i++) {
          if (d[i].id === 'sp_industry_all') {
            this.total = d[i];
          } else if (d[i].id === 'sp_industry_rest') {
            this.other = d[i];
          } else {
            d[i].subset = d[i].child.map(item=>{
              return {
                ...item,
                code: item.id,
                selectedCode: item.code
              }
            });
            this.tdata.push(d[i]);
          }
        }
        this.tdata[0].subState = true;
      },
      setChartDate() {
        let data = this.tdata;
        let capital = [];
        let inflow = [];
        let name1 = [];
        let name2 = [];
        this.allDate = {
          其他: { [this.codeKey]: 999991 }
        };
        this.partDate = {};
        this.capitalAll = 0;
        this.inflowAll = 0;
        for (let i = 0; i < data.length; i++) {
          if (data[i].share_market_capital) {
            this.capitalAll += data[i].share_market_capital - 0;
          }
          if (data[i][this.codeKey]) {
            this.allDate[data[i][this.codeKey]] = data[i];
          }
          if (data[i].name) {
            this.allDate[data[i].name] = data[i];
          }
          if (data[i].child) {
            let childs = data[i].child;
            for (let item in childs) {
              if (childs[item][this.codeKey]) {
                this.partDate[childs[item][this.codeKey]] = childs[item];
              }
              if(childs[item].id){
                this.partDate[childs[item].id] = childs[item];
              }
              if (childs[item].name) {
                this.partDate[childs[item].name] = childs[item];
              }
            }
          }
        }
        this.other1Code = [];
        this.other2Code = [];
        let other1 = {
          name: '其他',
          value: 0
        };
        let other2 = {
          name: '其他',
          value: 0
        };
        for (let i = 0; i < data.length; i++) {
          if (data[i].share_market_capital && data[i].share_market_capital - (this.total.share_market_capital || 0) / 100 >= 0) {
            let obj = {};
            obj.name = data[i].name;
            obj.value = data[i].share_market_capital;
            if (obj.value < (this.capitalAll / 100) * 5) {
              obj.label = {
                show: false
              };
              obj.labelLine = {
                show: false
              };
              obj.emphasis = {
                label: { show: true },
                labelLine: { show: true }
              };
            }
            capital.push(obj);
          } else {
            this.other1Code.push(data[i][this.codeKey]);
            other1.value += data[i].share_market_capital - 0;
          }
          if (data[i].accumulated_net_inflow && data[i].accumulated_net_inflow - this.total.accumulated_net_inflow / 100 >= 0) {
            let obj = {};
            obj.name = data[i].name;
            obj.value = data[i].accumulated_net_inflow;
            if (obj.value < (this.inflowAll / 100) * 5) {
              obj.label = {
                show: false
              };
              obj.labelLine = {
                show: false
              };
              obj.emphasis = {
                label: { show: true },
                labelLine: { show: true }
              };
            }
            inflow.push(obj);
          } else {
            this.other2Code.push(data[i][this.codeKey]);
            other2.value += data[i].share_market_capital - 0;
          }
        }
        if (other1.value) {
          if (other1.value < (this.capitalAll / 100) * 5) {
            other1.label = {
              show: false
            };
            other1.labelLine = {
              show: false
            };
            other1.emphasis = {
              label: { show: true },
              labelLine: { show: true }
            };
          }
          capital.push(other1);
        }
        if (other2.value) {
          if (other2.value < (this.inflowAll / 100) * 5) {
            other2.label = {
              show: false
            };
            other2.labelLine = {
              show: false
            };
            other2.emphasis = {
              label: { show: true },
              labelLine: { show: true }
            };
          }
          inflow.push(other2);
        }
        this.optCapital1.series[0].data = capital;
        this.optInflow1.series[0].data = inflow;
        if (!this.getchart) {
          this.getchartsInstance();
        }
        setTimeout(() => {
          this.selectedCode1 = this.tdata[0][this.codeKey];
        }, 1000);
        setTimeout(() => {
          this.selectedCode2 = this.tdata[0].subset[0][this.codeKey];
        }, 1500);
      },
      setChart2Date(parent) {
        let data = this.allDate[parent].subset;
        let capital = [];
        let inflow = [];
        let name = [];
        let capitalAll = 0;
        let inflowAll = 0;
        for (let i = 0; i < data.length; i++) {
          if (data[i].share_market_capital) {
            let obj = {};
            obj.name = data[i].name;
            obj.value = data[i].share_market_capital;
            capital.push(obj);
            capitalAll += data[i].share_market_capital - 0;
          }
          if (data[i].accumulated_net_inflow) {
            let obj = {};
            obj.name = data[i].name;
            obj.value = data[i].accumulated_net_inflow;
            inflow.push(obj);
            inflowAll += data[i].accumulated_net_inflow - 0;
          }
        }
  
        this.optCapital2.series[0].data = capital;
        this.optInflow2.series[0].data = inflow;
  
        if (this.chartType === 'capital') {
          this.chart2.setOption(this.optCapital2);
        } else {
          this.chart2.setOption(this.optInflow2);
        }
      },
      setChart2DateOther(d1, d2) {
        if (d1 && d1.length > 0) {
          let capital = [];
          let capitalAll = 0;
          for (let i = 0; i < d1.length; i++) {
            if (d1[i].share_market_capital) {
              let obj = {};
              obj.name = d1[i].name;
              obj.value = d1[i].share_market_capital;
              capital.push(obj);
              capitalAll += d1[i].share_market_capital - 0;
            }
          }
          for (let i = 0; i < d1.length; i++) {
            if (capital[i].value < (capitalAll / 100) * 5) {
              capital[i].label = {
                show: false
              };
              capital[i].labelLine = {
                show: false
              };
              capital[i].emphasis = {
                label: { show: true },
                labelLine: { show: true }
              };
            }
          }
          this.optCapital2.series[0].data = capital;
        }
        // if (d2 && d2.length > 0) {
        //   let inflow = [];
        //   let inflowAll = 0;
        //   for (let i = 0; i < d2.length; i++) {
        //     if (d2[i].accumulated_net_inflow) {
        //       let obj = {};
        //       obj.name = d2[i].name;
        //       obj.value = d2[i].accumulated_net_inflow;
        //       inflow.push(obj);
        //       inflowAll += d2[i].accumulated_net_inflow - 0;
        //     }
        //   }
        //   for (let i = 0; i < d2.length; i++) {
        //     if (inflow[i].value < (inflowAll / 100) * 5) {
        //       inflow[i].label = {
        //         show: false
        //       };
        //       inflow[i].labelLine = {
        //         show: false
        //       };
        //       inflow[i].emphasis = {
        //         label: { show: true },
        //         labelLine: { show: true }
        //       };
        //     }
        //   }
        //   this.optInflow2.series[0].data = inflow;
        // }
        if (this.chartType === 'capital') {
          this.chart2.setOption(this.optCapital2);
        } else {
          this.chart2.setOption(this.optInflow2);
        }
      },
      setCompareDate(d) {
        let time = [];
        let inflow = [];
        let capital = [];
        for (let i = 0; i < d.length; i++) {
          if (d[i].share_market_capital) {
            let date = d[i].date.split('-').join('');
            time.push(date);
            capital.push(d[i].share_market_capital - 0);
          }
        }
        // 陆股通不需要流入净额
        this.optCompare.legend.data = [{ name: '持股市值', icon: 'rect' }];
          this.optCompare.series = [
          {
              data: capital,
              type: 'line',
              name: '持股市值',
              showSymbol: false,
              smooth: true
            }
          ];
        this.optCompare.xAxis.data = time;
        this.chartCompare.setOption(this.optCompare);
      },
      rowClick(e, data, target) {
        this.selectId = data.id;
        if (e.target.tagName === 'SPAN' && e.target.className === 'icon-sub') {
          this.$refs.hqtable.setSubState(target.getAttribute('idx'));
          if (this.type.type - 0 === 1) {
            if (data.subState) {
              TA.log({ id: 'cgpz_lgt_hytj_43', _sid: 'cgpz_lgt_hytj_43' });
            } else {
              TA.log({ id: 'cgpz_lgt_hytj_44', _sid: 'cgpz_lgt_hytj_44' });
            }
          } else {
            if (data.subState) {
              TA.log({ id: 'cgpz_ggt_hytj_43', _sid: 'cgpz_ggt_hytj_43' });
            } else {
              TA.log({ id: 'cgpz_ggt_hytj_44', _sid: 'cgpz_ggt_hytj_44' });
            }
          }
        } else {
          if (this.type.type - 0 === 1) {
            TA.log({ id: 'cgpz_lgt_hytj_40', _sid: 'cgpz_lgt_hytj_40' });
          } else {
            TA.log({ id: 'cgpz_ggt_hytj_40', _sid: 'cgpz_ggt_hytj_40' });
          }
          if (!data.isSub) {
            this.$refs.hqtable.setActiveIndex(target.getAttribute('idx'));
            let code = target.getAttribute('idx');
            if (this.other1Code.indexOf(code) >= 0 || this.other2Code.indexOf(code) >= 0) {
              this.selectedCode1 = 999991;
            }
            if (this.selectedCode1 === target.getAttribute('idx') && this.selectedCode1 !== this.selectedCode) {
              this.selectedCode1 = 999992;
            }
           
            setTimeout(() => {
              this.selectedCode1 = target.getAttribute('idx');
            }, 100);
          } else {
            this.$refs.hqtable.setActiveIndex(target.getAttribute('idx'));
            let pic = data.parent_id;
            if(this.other1Code.indexOf(data.code)>=0){
              this.selectedCode1 = pic;
              let type = 'capital';
              this.randerOther(type);
            }else{
              this.selectedCode1 = pic;
            }
            setTimeout(() => {
              this.selectedCode2 = target.getAttribute('idx');
            }, 500);
          }
        }
      },
      rechart(val) {
        if (!this.getchart) return;
        let w = 0;
        let w1 = 0;
        if (val < 1820) {
          w = (val - 137) / 2;
          w1 = val - 142;
        } else {
          w = (val - 137 - 8) / 4;
          w1 = (val - 142 - 5) / 2;
        }
        let opts = {
          width: w
        };
        let opts1 = {
          width: w1
        };
        this.chart1.resize(opts);
        this.chart2.resize(opts);
        this.chartCompare.resize(opts1);
        this.changeSelected1(true);
        this.changeSelected2(true);
        this.drewMarkLine();
        this.$refs.hqtable.resize();
      },
      randerOther(type) {
        if (type === 'capital') {
          let capital = 0;
          let child1 = [];
          for (let i in this.other1Code) {
            capital += this.allDate[this.other1Code[i]].share_market_capital - 0;
            child1 = child1.concat(this.allDate[this.other1Code[i]].subset);
          }
          this.selectedAngel1 = (capital / 2 / this.capitalAll) * 360;
          let capitalAngle = 360 - (capital / 2 / this.capitalAll) * 360;
          this.optCapital1.series[0].startAngle = capitalAngle;
  
          this.setChart2DateOther(child1, []);
        } else {
          let inflow = 0;
          let child2 = [];
          for (let j in this.other2Code) {
            inflow += this.allDate[this.other2Code[j]].accumulated_net_inflow - 0;
            child2 = child2.concat(this.allDate[this.other2Code[j]].subset);
          }
          this.selectedAngel2 = (inflow / 2 / this.inflowAll) * 360;
          let inflowAngle = 360 - (inflow / 2 / this.inflowAll) * 360;
          this.optInflow1.series[0].startAngle = inflowAngle;
        }
        if (this.chartType === 'capital') {
          this.chart1.setOption(this.optCapital1);
        } else {
          this.chart1.setOption(this.optInflow1);
        }
        this.chart1.dispatchAction({
          type: 'pieSelect',
          name: '其他'
        });
        this.drewMarkLine();
      },
      changeSelected1(bol) {
        let val = this.selectedCode1;
        this.selectedCode2 = '';
        if (val - 0 === 999991) {
          //其他
          let inflow = 0;
          let capital = 0;
          let child1 = [];
          let child2 = [];
          for (let i in this.other1Code) {
            capital += this.allDate[this.other1Code[i]].share_market_capital - 0;
            child1 = child1.concat(this.allDate[this.other1Code[i]].subset);
          }
          for (let j in this.other2Code) {
            inflow += this.allDate[this.other2Code[j]].accumulated_net_inflow - 0;
            child2 = child2.concat(this.allDate[this.other2Code[j]].subset);
          }
          this.selectedAngel1 = (inflow / 2 / this.inflowAll) * 360;
          this.selectedAngel2 = (capital / 2 / this.capitalAll) * 360;
          let inflowAngle = 360 - (inflow / 2 / this.inflowAll) * 360;
          let capitalAngle = 360 - (capital / 2 / this.capitalAll) * 360;
          this.optCapital1.series[0].startAngle = capitalAngle;
          this.optInflow1.series[0].startAngle = inflowAngle;
  
          if (this.chartType === 'capital') {
            this.chart1.setOption(this.optCapital1);
          } else {
            this.chart1.setOption(this.optInflow1);
          }
  
          this.drewMarkLine();
  
          this.chart1.dispatchAction({
            type: 'pieSelect',
            name: '其他'
          });
          this.setChart2DateOther(child1, child2);
          this.$refs.hqtable.setActiveIndex(val);
        } else {
          this.setChart2Date(val);
          // 计算旋转角度
          let lock = false;
          let inflow = 0;
          let capital = 0;
          let inflowStart = 0;
          let capitalStart = 0;
          for (let i in this.tdata) {
            if (this.tdata[i][this.codeKey] === val) {
              lock = true;
              inflow = this.tdata[i].accumulated_net_inflow - 0;
              capital = this.tdata[i].share_market_capital - 0;
            }
            if (!lock && this.other1Code.indexOf(this.tdata[i][this.codeKey]) < 0) {
              capitalStart += this.tdata[i].share_market_capital - 0;
            }
            if (!lock && this.other2Code.indexOf(this.tdata[i][this.codeKey]) < 0) {
              inflowStart += this.tdata[i].accumulated_net_inflow - 0;
            }
          }
          let inflowAngle = ((inflowStart + inflow / 2) / this.inflowAll) * 360;
          let capitalAngle = ((capitalStart + capital / 2) / this.capitalAll) * 360;
          this.selectedAngel1 = (inflow / 2 / this.inflowAll) * 360;
          this.selectedAngel2 = (capital / 2 / this.capitalAll) * 360;
          this.optCapital1.series[0].startAngle = capitalAngle;
          this.optInflow1.series[0].startAngle = inflowAngle;
  this.chart1.setOption(this.optCapital1);
  
          this.drewMarkLine();
          // 选择元素
          let currentName = this.allDate[val].name;
  
          this.chart1.dispatchAction({
            type: 'pieSelect',
            name: currentName
          });
  
          if (!bol) {
            this.selectedCode = val;
            this.selectName = currentName;
            this.getCompareDate();
          }
          this.$refs.hqtable.setActiveIndex(val);
        }
      },
      changeSelected2(bol) {
        let val = this.selectedCode2;
        if (!val) return;
        let currentName = this.partDate[val].name;
  
        this.chart2.dispatchAction({
          type: 'pieSelect',
          name: currentName
        });
  
        if (!bol) {
          this.selectedCode = val;
          this.selectName = currentName;
          this.$refs.hqtable.setActiveIndex(val);
          this.getCompareDate();
        }
      },
      foldBtn() {
        if (this.type.type - 0 === 1) {
          if (this.foldAll) {
            TA.log({ id: 'cgpz_lgt_hytj_46', _sid: 'cgpz_lgt_hytj_46' });
          } else {
            TA.log({ id: 'cgpz_lgt_hytj_45', _sid: 'cgpz_lgt_hytj_46' });
          }
        } else {
          if (this.foldAll) {
            TA.log({ id: 'cgpz_ggt_hytj_46', _sid: 'cgpz_ggt_hytj_46' });
          } else {
            TA.log({ id: 'cgpz_ggt_hytj_45', _sid: 'cgpz_ggt_hytj_46' });
          }
        }
        for (let i = 0; i < this.tdata.length; i++) {
          this.tdata[i].subState = !this.foldAll;
        }
        this.foldAll = !this.foldAll;
        this.$refs.hqtable.setActiveIndex(this.selectedCode);
      },
      drewMarkLine() {
        this.markLine.clearRect(0, 0, 600, 300);
        this.markLine.strokeStyle = '#868686';
        let x1 = 150 + Math.cos((this.selectedAngel2 / 360) * Math.PI) * 50;
        let y1 = Math.sin((this.selectedAngel2 / 360) * Math.PI) * 50;
        this.markLine.beginPath();
        this.markLine.moveTo(x1, 150 + y1);
        this.markLine.lineTo(440, 230);
        this.markLine.moveTo(x1, 150 - y1);
        this.markLine.lineTo(440, 70);
        this.markLine.stroke();
      },
      clickOther(val) {
        this.selectedCode1 = val;
        this.selectedCode2 = '';
        this.selectedCode = val;
        this.selectName = '全部';
        this.selectId = 'sp_industry_all';
        this.getCompareDate();
        this.$refs.hqtable.setActiveIndex(val);
      },
      changeType(val) {
        if (this.type.type - 0 === 1) {
          if (this.chartType === 'capital') {
            TA.log({ id: 'cgpz_lgt_hytj_31', _sid: 'cgpz_lgt_hytj_31' });
          } else {
            TA.log({ id: 'cgpz_lgt_hytj_30', _sid: 'cgpz_lgt_hytj_30' });
          }
        } else {
          if (this.chartType === 'capital') {
            TA.log({ id: 'cgpz_ggt_hytj_31', _sid: 'cgpz_ggt_hytj_31' });
          } else {
            TA.log({ id: 'cgpz_ggt_hytj_30', _sid: 'cgpz_ggt_hytj_30' });
          }
        }
  
        if (this.chartType !== val) {
          this.chartType = val;
          this.changeSelected1(true);
          this.changeSelected2(true);
        }
      },
      jumptoALl() {
        if (this.type.type === 1) {
          API.use({
            method: 'Quote.switchPage',
            data: {
              id: '65',
              code: '120:000985'
            }
          });
        } else {
          API.use({
            method: 'Quote.switchPage',
            data: {
              id: '65',
              code: 'HSHKI'
            }
          });
        }
      },
      tooltipTarget() {
        clearTimeout(this.tipTimer);
        this.tipTimer = setTimeout(() => {
          if (this.type.type - 0 === 1) {
            TA.log({ id: 'cgpz_lgt_hytj_50', _sid: 'cgpz_lgt_hytj_50' });
          } else {
            TA.log({ id: 'cgpz_ggt_hytj_50', _sid: 'cgpz_ggt_hytj_50' });
          }
        }, 800);
      },
      target() {
        if (this.type.type - 0 === 1) {
          TA.log({ id: 'cgpz_lgt_hytj_42', _sid: 'cgpz_lgt_hytj_42' });
        } else {
          TA.log({ id: 'cgpz_ggt_hytj_42', _sid: 'cgpz_ggt_hytj_42' });
        }
      },
      chartCompareDatazoom() {
        if (this.type.type - 0 === 1) {
          TA.log({ id: 'cgpz_lgt_hytj_51', _sid: 'cgpz_lgt_hytj_51' });
        } else {
          TA.log({ id: 'cgpz_ggt_hytj_51', _sid: 'cgpz_ggt_hytj_51' });
        }
      },
      chart1Mouseover() {
        if (this.type.type - 0 === 1) {
          if (this.chartType === 'capital') {
            TA.log({ id: 'cgpz_lgt_hytj_30_2', _sid: 'cgpz_lgt_hytj_30_2' });
          } else {
            TA.log({ id: 'cgpz_lgt_hytj_31_2', _sid: 'cgpz_lgt_hytj_31_2' });
          }
        } else {
          if (this.chartType === 'capital') {
            TA.log({ id: 'cgpz_ggt_hytj_30_2', _sid: 'cgpz_ggt_hytj_30_2' });
          } else {
            TA.log({ id: 'cgpz_ggt_hytj_31_2', _sid: 'cgpz_ggt_hytj_31_2' });
          }
        }
      },
      chart2Mouseover() {
        if (this.type.type - 0 === 1) {
          if (this.chartType === 'capital') {
            TA.log({ id: 'cgpz_lgt_hytj_30_4', _sid: 'cgpz_lgt_hytj_30_4' });
          } else {
            TA.log({ id: 'cgpz_lgt_hytj_31_4', _sid: 'cgpz_lgt_hytj_31_4' });
          }
        } else {
          if (this.chartType === 'capital') {
            TA.log({ id: 'cgpz_ggt_hytj_30_4', _sid: 'cgpz_ggt_hytj_30_4' });
          } else {
            TA.log({ id: 'cgpz_ggt_hytj_31_4', _sid: 'cgpz_ggt_hytj_31_4' });
          }
        }
      }
    },
    computed: {
      isLgt(){
        return this.type.typename === '陆股通'
      },
      typename() {
        return this.type.typename;
      },
      foldBtnContent() {
        if (!this.foldAll) {
          return '一键展开二级行业';
        } else {
          return '一键收起二级行业';
        }
      },
      tableTips() {
        if (this.datafault) {
          return '网络开了小差，过会就回来';
        } else {
          return '数据飞速加载中...';
        }
      }
    },
    watch: {
      date: {
        handler(newval, oldval) {
          this.sort = { key: 'share_market_capital', type: 'down' };
          if (newval) {
              this.getDate();
          }
        },
        immediate: true
      },
      resizeType(val) {
        this.rechart(this.resize);
      },
      selectedCode1(val, old) {
        if (old && old !== 999991 && old !== 999992) {
          let oldName = this.allDate[old].name;
          this.chart1.dispatchAction({
            type: 'pieUnSelect',
            name: oldName
          });
        }
        if (val === this.selectedCode || !val || val - 0 === 999992) return;
        this.changeSelected1(!old);
      },
      selectedCode2(val, old) {
        if (old) {
          let oldName = this.partDate[old].name;
          this.chart2.dispatchAction({
            type: 'pieUnSelect',
            name: oldName
          });
        }
  
        if (val === old || !val) return;
        this.changeSelected2();
      },
      color() {
        this.optCapital1.color = this.color.color;
        this.optCapital2.color = this.color.color;
        this.optInflow1.color = this.color.color;
        this.optInflow2.color = this.color.color;
        this.optCapital1.series[0].label.color = this.color.label;
        this.optCapital2.series[0].label.color = this.color.label;
        this.optInflow1.series[0].label.color = this.color.label;
        this.optInflow2.series[0].label.color = this.color.label;
        this.optCapital1.series[0].labelLine.lineStyle.color = this.color.labelLine;
        this.optCapital2.series[0].labelLine.lineStyle.color = this.color.labelLine;
        this.optInflow1.series[0].labelLine.lineStyle.color = this.color.labelLine;
        this.optInflow2.series[0].labelLine.lineStyle.color = this.color.labelLine;
      }
    }
  };
  </script>
  
  <style scoped>
  .industy-block {
    position: relative;
  }
  .fold-btn {
    position: absolute;
    top: -21px;
    right: 10px;
    font-size: 12px;
    /* color: #b3b3b3; */
    cursor: pointer;
  }
  .fold-btn:hover {
    color: #b40606;
  }
  .top-charts {
    height: 300px;
    padding: 7px 0 10px;
    display: flex;
    flex-direction: row;
    position: relative;
  }
  
  .table {
    widows: 100%;
    height: 400px;
    margin: 0 auto;
    font-size: 12px;
  }
  .chart {
    /* flex-grow: 1; */
    flex: 1;
    height: 300px;
    /* flex-shrink: 0; */
    min-width: 300px;
  }
  
  .chart-tag {
    position: absolute;
    font-size: 14px;
    padding-left: 5px;
    left: 10px;
    top: 5px;
    z-index: 100;
    display: flex;
  }
  .chart-title {
    position: absolute;
    font-size: 12px;
    padding-left: 5px;
    left: 10px;
    top: 3px;
  }
  .chart-tag .chart-title-tag {
    border-bottom: 2px solid;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    color: #8c929c;
    padding: 0 10px;
  }
  .chart-tag .selected {
    color: #ce8263;
  }
  .bottom-chart {
    height: 300px;
    position: relative;
    margin-top: 20px;
  }
  
  .mark-line {
    position: absolute;
    width: 100%;
    height: 300px;
  }                                                    
  .mk {
    width: 100%;
    height: 300px;
  }
  
  .table >>> div[thead-key='name'],
  .table >>> div[td-key='name'] > div {
    text-align: left;
  }
  .table >>> div[thead-key='name'],
  .table >>> div[td-key='name'] {
    padding-left: 5px;
  }
  .table >>> div[thead-key='selectedCode'],
  .table >>> div[td-key='selectedCode'] {
    text-align: left;
  }
  .table >>> .txt-hide{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    padding-right: 5px;
  }
  .table >>> .hq_container_theadfixed {
    width: 100% !important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/block/lgtIndustryblock.vue